/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ExposedInvariantValidator } from "../ExposedInvariantValidator";

export class ExposedInvariantValidator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ExposedInvariantValidator> {
    return super.deploy(overrides || {}) as Promise<ExposedInvariantValidator>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ExposedInvariantValidator {
    return super.attach(address) as ExposedInvariantValidator;
  }
  connect(signer: Signer): ExposedInvariantValidator__factory {
    return super.connect(signer) as ExposedInvariantValidator__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ExposedInvariantValidator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ExposedInvariantValidator;
  }
}

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_i",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rawInput",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "computeMint",
    outputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8[]",
        name: "_indices",
        type: "uint8[]",
      },
      {
        internalType: "uint256[]",
        name: "_rawInputs",
        type: "uint256[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "computeMintMulti",
    outputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_o",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_netMassetQuantity",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "computeRedeem",
    outputs: [
      {
        internalType: "uint256",
        name: "rawOutputUnits",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8[]",
        name: "_indices",
        type: "uint8[]",
      },
      {
        internalType: "uint256[]",
        name: "_rawOutputs",
        type: "uint256[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "computeRedeemExact",
    outputs: [
      {
        internalType: "uint256",
        name: "totalmAssets",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_i",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_o",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rawInput",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_feeRate",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "computeSwap",
    outputs: [
      {
        internalType: "uint256",
        name: "bAssetOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "scaledSwapFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "getK",
    outputs: [
      {
        internalType: "uint256",
        name: "k",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";
